
export const optionsSposobyDostarczenia = [
    {id: 'Listownie', nazwa: 'Listownie'},
    {id: 'Odbiór osobisty', nazwa: 'Odbiór osobisty'},
    {id: 'e-Puap', nazwa: 'e-Puap'},
]

export const optionsRodzajIdentyfikatora = [
    {id: 'NIP', nazwa: 'NIP'},
    {id: 'REGON', nazwa: 'REGON'},
    {id: 'PESEL', nazwa: 'PESEL'},
]

export const optionsTypPodmiotu = [
    {id: 'Jednostka', nazwa: 'Jednostka'},
    {id: 'Inwestor', nazwa: 'Inwestor'},
]

export const optionsTakNie = [
    {id: 'Tak', nazwa: 'Tak'},
    {id: 'Nie', nazwa: 'Nie'},
]

export const optionsTakNieNd = [
    {id: 'Tak', nazwa: 'Tak'},
    {id: 'Nie', nazwa: 'Nie'},
    {id: 'Nie dotyczy', nazwa: 'Nie dotyczy'},
]

export const optionsKategoriaProjektu  = [
    {id: 'A', nazwa: 'A'},
    {id: 'B', nazwa: 'B'},
]

export const optionsHarmStatus = [
    {id: "W_EDYCJI", nazwa: "W_EDYCJI"},
    {id: "ZŁOŻONY", nazwa: "ZŁOŻONY"},
    {id: "PRZYJĘTY", nazwa: "PRZYJĘTY"},
]

export const optionsProjektStatus = [
    {id: "W_EDYCJI", nazwa: "W_EDYCJI"},
    {id: "ZŁOŻONA", nazwa: "ZŁOŻONA"},
    {id: "PRZYJĘTA", nazwa: "PRZYJĘTA"},
    {id: "DO_POPRAWY", nazwa: "DO_POPRAWY"},
    {id: "ZAKOŃCZONA", nazwa: "ZAKOŃCZONA"},
    {id: "ANULOWANA", nazwa: "ANULOWANA"},
    {id: "ARCHIWALNA", nazwa: "ARCHIWALNA"}
]

export const optionsProjektStatusSpr = [
    {id: "etap_przygotowania", nazwa: "Etap przygotowania"},
    {id: "etap_realizacji", nazwa: "Etap realizacji"},
    {id: "etap_zamykania", nazwa: "Etap zamykania"}
]

export const optionsSprawozdanieStatus = [
    {id: "W_EDYCJI", nazwa: "W_EDYCJI"},
    {id: "ZŁOŻONY", nazwa: "ZŁOŻONY"},
    {id: "PRZYJĘTY", nazwa: "PRZYJĘTY"},
    {id: "DO_POPRAWY", nazwa: "DO_POPRAWY"},
    {id: "ZAKOŃCZONY", nazwa: "ZAKOŃCZONY"}
]

export const optionsTypJednostki = [
    { nazwa: 'Departament', id: 'departament' },
    { nazwa: 'Jednostka podległa', id: 'jednostka' },
]
export const optionsRodzajJednostki = [
    { nazwa: 'Jednostka budżetowa (B)', id: 'B' },
    { nazwa: 'Wojewódzka osoba prawna (P)', id: 'P' },
    { nazwa: 'Spółka (S)', id: 'S' },
]

export const optionsPrawdopodobienstwo = [
    { label: 'Małe', value: 'male' },
    { label: 'Średnie', value: 'srednie' },
    { label: 'Duże', value: 'duze' },
]

export const optionsSkutek = [
    { label: 'Mały', value: 'maly' },
    { label: 'Średni', value: 'sredni' },
    { label: 'Duży', value: 'duzy' },
]

export const optionsStatusRyzyka = [
    { label: 'Aktualne', value: 'Aktualne', variant: 'warning' },
    { label: 'Ustąpiło', value: 'Ustąpiło', variant: 'success' },
    { label: 'Wystąpiło', value: 'Wystąpiło', variant: 'danger' },
]

export const optionsOcenaRealizacji = [
    { value: 'Nie rozpoczęty', label: 'Nie rozpoczęty', variant: 'secondary' },
    { value: 'Zgodnie z planem', label: 'Zgodnie z planem', variant: 'success' },
    { value: 'Mogą wystąpić problemy', label: 'Mogą wystąpić problemy', variant: 'warning' },
    { value: 'Jest problem!', label: 'Jest problem!', variant: 'danger' },
]

export const optionsPowodAnulowania = [
    {id: 'rezygnacja z projektu', nazwa: 'Rezygnacja z projektu'},
    {id: 'nie podlega Zasadom', nazwa: 'Nie podlega Zasadom'},
]

export default {
    optionsSposobyDostarczenia,
    optionsRodzajIdentyfikatora,
    optionsTypPodmiotu,
    optionsTakNie,
    optionsTakNieNd,
    optionsKategoriaProjektu,
    optionsHarmStatus,
    optionsTypJednostki,
    optionsRodzajJednostki,
    optionsPowodAnulowania,
    optionsOcenaRealizacji,
    optionsStatusRyzyka,
    optionsSkutek,
    optionsPrawdopodobienstwo
}